<div fxLayout="column" id="htmlData" hidden #htmlData fxLayoutAlign="center center" class="certificate-container"
  [ngStyle]="{'background-image': 'url(' + serverPath + certificateBackgroundImg + ')', 'background-repeat': 'no-repeat', 'background-size': 'cover'}">
  <div fxLayout="column" fxLayoutAlign="center center" class="certificate-header">
    <div class="certificate-title">
      <span class="title-main">CERTIFICATE</span>
    </div>
    <div class="certificate-title">
      <span class="title-sub">OF APPRECIATION</span>
    </div>
  </div>
  <div fxLayout="column" fxLayoutAlign="center center" class="certificate-body">
    <div class="certificate-award-text">
      <span class="award-text">THE FOLLOWING AWARD IS GIVEN TO</span>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" class="certificate-recipient">
      <span class="recipient-name">
        <h1 style="color: black;" fxLayoutAlign="start">{{username}}</h1>
      </span>
      <div class="recipient-underline"></div>
    </div>
    <div class="certificate-description">
      <span>This certificate is given to 
        <h1  style="color: black;" fxLayoutAlign="start">{{username}}</h1>
      </span>
      <span>for Successfully Completing the <span [innerHTML]="product.name"></span></span>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between center" class="certificate-footer">
    <div class="certificate-footer-left">
      <img [src]="serverPath1 + courseManagerSign" alt="Signature" style="width:140px;height:36px;">
      <div class="footer-underline"></div>
      <span>Professor</span>
    </div>
    <div class="certificate-footer-image" style="margin: 0px 96px;">
      <img src="src/assets/img/grd.png" alt="" style="width:100%;">
    </div>
    <div class="certificate-footer-right">
      <img [src]="LecturerServerPath+LectureDetails?.logo" alt="Signature" style="width:140px;height:36px;">
      <div class="footer-underline"></div>
      <span>Mentor</span>
    </div>
  </div>
</div>
